/**
 * In-memory stale-while-revalidate cache for Team Management views.
 * Survives navigating away and back (same session); keyed by business id.
 * Cleared on logout via auth middleware.
 */

const store = Object.create(null);

export const TEAM_MGMT_CACHE_TABS = {
  AGENTS: 'agents',
  SUPERVISORS: 'supervisors',
  ALL_USERS: 'allUsers',
  GROUPS: 'groups',
  SUSPENDED_USERS: 'suspendedUsers',
  SUSPENDED_GROUPS: 'suspendedGroups',
};

function makeKey(businessId, tab) {
  return `${businessId ?? 'anon'}::${tab}`;
}

/**
 * @param {string|undefined} businessId
 * @param {string} tab — use TEAM_MGMT_CACHE_TABS
 * @returns {{ rawData: unknown } | null}
 */
export function getTeamMgmtPeek(businessId, tab) {
  if (!businessId) return null;
  return store[makeKey(businessId, tab)] ?? null;
}

/**
 * @param {string|undefined} businessId
 * @param {string} tab
 * @param {unknown} rawData — JSON-serializable (e.g. API `data` array)
 */
export function setTeamMgmtPeek(businessId, tab, rawData) {
  if (!businessId) return;
  try {
    store[makeKey(businessId, tab)] = {
      rawData: JSON.parse(JSON.stringify(rawData)),
    };
  } catch {
    store[makeKey(businessId, tab)] = { rawData };
  }
}

export function clearTeamManagementViewCache() {
  for (const k of Object.keys(store)) {
    delete store[k];
  }
}
